import { MedicalItem } from "./MedicalItem";

class MedicalItemMedicalReaction extends MedicalItem {
    public OffendingAgent: string;
    public ActiveIngredient: string;
    public CodeGEN: string;
    public RecordedDate: Date;
    public ReactionDescription: string;
    public IsDeleted: boolean;
    public ClassPharmacological: string;
    public EndDate: Date;
    public SeverityLookupId: string;
    public SeverityLookupValue: string;
    public ReactionTypeLookupId: string;
    public ReactionTypeLookupValue: string;
    public ClinicalStatusLookupId: string;
    public ClinicalStatusLookupValue: string;
    public TypeLookupId: string;
    public TypeLookupValue: string;
}

export { MedicalItemMedicalReaction };
